export default __webpack_public_path__ + "alberta-ic-reminder.94f9655635e36e7e6704.svg";